import { useMutation } from '@tanstack/react-query'
import { IReferralRedeemPayload, redeemReferralReward } from '../referral'

export const useRedeemReferralReward = () => {
  const mutation = useMutation({
    mutationFn: (data: IReferralRedeemPayload) => redeemReferralReward(undefined, data)
  })

  return {
    redeemReferralReward: mutation.mutateAsync,
    isRedeemingReferralReward: mutation.isPending
  }
}
